import React from 'react'
import {FormattedMessage, defineMessage, useIntl} from 'react-intl'
import {useProductList} from '../util/product-list-context'

import {
    Drawer,
    DrawerBody,
    DrawerHeader,
    DrawerOverlay,
    DrawerContent,
    DrawerCloseButton,
    DrawerFooter,
    Text,
    Flex,
    Button
} from '@salesforce/retail-react-app/app/components/shared/ui'

// Icons
import {CloseIcon} from '../../../components/custom-icons'

import LoadingSpinner from '../../../components/loading-spinner'
import Refinements from './refinements'
import {useGTM} from '@app/hooks/use-gtm'

const REFINEMENT_DRAWER_LABEL = defineMessage({
    defaultMessage: 'Close Filter',
    id: 'refinements_drawer.close.aria_label'
})

const RefinementsDrawer = () => {
    const {formatMessage} = useIntl()
    const {
        isOpenRefinements,
        onCloseRefinements,
        refinementsOpenRef,
        refinementsCloseRef,
        isProductListLoading,
        productSearchResult,
        searchParams,
        resetFilters
    } = useProductList()
    const {triggerClickFiltersEvent} = useGTM()

    return (
        <Drawer
            isOpen={isOpenRefinements}
            onClose={onCloseRefinements}
            initialFocusRef={refinementsCloseRef}
            finalFocusRef={refinementsOpenRef}
            placement="right"
            size="md"
        >
            <DrawerOverlay />
            <DrawerContent>
                <DrawerHeader px={{base: 10, lg: 20}} py={24}>
                    {/* Using role="heading" instead of a semantic <h1> tag to avoid SEO impact */}
                    <Text
                        as="div"
                        role="heading"
                        aria-level="1"
                        variant="eyeBrowLarge"
                        textTransform="uppercase"
                        paddingRight={24}
                    >
                        <FormattedMessage
                            defaultMessage="Filter"
                            id="product_list.modal.title.filter"
                        />
                    </Text>
                </DrawerHeader>
                <DrawerCloseButton
                    ref={refinementsCloseRef}
                    aria-label={formatMessage(REFINEMENT_DRAWER_LABEL)}
                >
                    <CloseIcon
                        boxSize="14px"
                        svgTitle={formatMessage(REFINEMENT_DRAWER_LABEL)}
                        svgDescription={formatMessage(REFINEMENT_DRAWER_LABEL)}
                    />
                </DrawerCloseButton>

                <DrawerBody px={[10, 10, 10, 20]} py={[10, 10, 10, 10]}>
                    {isProductListLoading && <LoadingSpinner />}

                    <Refinements
                        isLoading={isProductListLoading}
                        filters={productSearchResult?.refinements}
                        sortingOptions={productSearchResult?.sortingOptions}
                        selectedFilters={searchParams.refine}
                    />
                </DrawerBody>

                <DrawerFooter display="block" width="full" px={[10, 10, 10, 20]} py={20}>
                    <Flex gap={10}>
                        <Button variant="secondary" flex="1" onClick={resetFilters}>
                            <FormattedMessage
                                defaultMessage="Clear All"
                                id="product_list.modal.button.clear_filters"
                            />
                        </Button>
                        <Button
                            variant="primary"
                            flex="1"
                            // onClick={onCloseRefinements}
                            onClick={() => {
                                triggerClickFiltersEvent(
                                    {
                                        refinements: productSearchResult?.refinements,
                                        selectedRefinements:
                                            productSearchResult?.selectedRefinements
                                    },
                                    {
                                        sortingOptions: productSearchResult?.sortingOptions,
                                        selectedSortingOption:
                                            productSearchResult?.selectedSortingOption
                                    }
                                )
                                onCloseRefinements()
                            }}
                        >
                            <FormattedMessage
                                defaultMessage="{productCount, plural, =0 {No items} one {Apply ({productCount} item)} other {Apply ({productCount} items)}}"
                                values={{productCount: productSearchResult?.total || 0}}
                                id="product_list.modal.button.apply_items"
                            />
                        </Button>
                    </Flex>
                </DrawerFooter>
            </DrawerContent>
        </Drawer>
    )
}

RefinementsDrawer.propTypes = {}

export default RefinementsDrawer
